import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { Bundle, BundleListResponse, BundleQueryParams, CreateBundle, UpdateBundle, VerifiedBundleListResponse } from '@frontend/bundle/types';

export class BundleClient extends APIClient {
    public static readonly endpoint = '/account-api/v1';

    public static async fetchBundles(queryParams?: ApiQueryParams<BundleQueryParams>, withCredentials?: Token): Promise<BundleListResponse> {
        return await this.apiPaginated<BundleListResponse, BundleQueryParams>(`${this.endpoint}/bundles`, queryParams, withCredentials);
    }

    public static async fetchVerifiedBundles(queryParams?: ApiQueryParams<BundleQueryParams>, withCredentials?: Token): Promise<VerifiedBundleListResponse> {
        return await this.apiPaginated<VerifiedBundleListResponse, BundleQueryParams>(`${this.endpoint}/verified-bundles`, queryParams, withCredentials);
    }

    public static async resolveBundles(ids: string[], field: string = 'id'): Promise<BundleListResponse> {
        return this.resolve<BundleListResponse>(`${this.endpoint}/bundles`, ids, field);
    }

    public static async deleteBundles(ids: string[], forceDelete = false): Promise<void> {
        const url = `${this.endpoint}/bundles-delete${forceDelete ? '?force_delete=true' : ''}`;
        const response = await this.post(url, { ids });
        return await this.handleVoidResponse(response);
    }

    public static async postBundle(accountId: string, body: CreateBundle): Promise<Bundle> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/bundles`, body);
        return await this.handleResponse<Bundle>(response);
    }

    public static async fetchBundle(accountId: string, bundleId: string): Promise<Bundle> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/bundles/${bundleId}`);
        return await this.handleResponse<Bundle>(response);
    }

    public static async patchBundle(accountId: string, bundleId: string, body: UpdateBundle): Promise<Bundle> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/bundles/${bundleId}`, body);
        return await this.handleResponse<Bundle>(response);
    }

    public static async deleteBundle(accountId: string, bundleId: string, forceDelete = false): Promise<void> {
        const url = `${this.endpoint}/accounts/${accountId}/bundles/${bundleId}${forceDelete ? '?force_delete=true' : ''}`;
        const response = await this.delete(url);
        return await this.handleVoidResponse(response);
    }
}
